import { useNotificationContext } from '../context/NotificationContext';
export const useNotification = () => useNotificationContext();
